export default __webpack_public_path__ + "static/media/tours.39e27ab0.jpg";